import { styled } from "styled-components";

export const Table = styled.table`
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  tbody {
    width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${({ theme }) => theme.breakpoints.sm.query} {
    flex-direction: column;
  }
`;
